import { css } from 'lit';

export const tableCss = css`
  .numerical {
    text-align: right;
  }
`;
